import React, { useEffect, useState } from "react";
import axios from "../Components/Axios/Axios";
import { Container, Button, Card, Form, Col, Row } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../Components/Sidebar/MainSidebar/Sidebar";
// import CKEditor from "ckeditor4-react-advanced";
import { CKEditor } from "ckeditor4-react";

import Loader from "../Components/Spinner/Spinner";
import requests from "../Components/Requests/Requests";
// import {CKEditor} from "ckeditor4-react";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles
function AddFaq() {
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [status, setStatus] = useState("0");
  const [loading, setloading] = useState(false);
  const [content, setContent] = useState("");
  const [faqTypes, setFaqTypes] = useState([]);
  const [faqVideo, setFaqVideo] = useState("");
  const [faqkeywords, setFaqkeywords] = useState("");
  const [titles, setTitles] = useState({});
  const [descriptions, setDescriptions] = useState({});
  const LANGUAGES = [
    { key: "english", label: "English", code: "en" },
    { key: "russian", label: "Russian", code: "ru" },
    { key: "portuguese", label: "Portuguese", code: "pt" },
    { key: "german", label: "German", code: "de" },

    { key: "french", label: "French", code: "fr" },
    { key: "spanish", label: "Spanish", code: "es" },
    { key: "kazakh", label: "Kazakh", code: "kk" },
    { key: "hindi", label: "Hindi", code: "hi" },

    { key: "chinese_simplified", label: "Chinese (Simplified)", code: "zh-CN" },
    {
      key: "chinese_traditional",
      label: "Chinese (Traditional)",
      code: "zh-TW",
    },

    { key: "ukrainian", label: "Ukrainian", code: "uk" },
    { key: "arabic", label: "Arabic", code: "ar" },
    { key: "turkish", label: "Turkish", code: "tr" },
    { key: "hebrew", label: "Hebrew", code: "he" },

    { key: "italian", label: "Italian", code: "it" },
    { key: "catalan", label: "Catalan", code: "ca" },
    { key: "croatian", label: "Croatian", code: "hr" },
    { key: "czech", label: "Czech", code: "cs" },

    { key: "danish", label: "Danish", code: "da" },
    { key: "dutch", label: "Dutch", code: "nl" },
    { key: "finnish", label: "Finnish", code: "fi" },
    { key: "greek", label: "Greek", code: "el" },

    { key: "hungarian", label: "Hungarian", code: "hu" },
    { key: "norwegian", label: "Norwegian", code: "no" },
    { key: "polish", label: "Polish", code: "pl" },
    { key: "romanian", label: "Romanian", code: "ro" },

    { key: "slovak", label: "Slovak", code: "sk" },
    { key: "swedish", label: "Swedish", code: "sv" },
    { key: "korean", label: "Korean", code: "ko" },
    { key: "thai", label: "Thai", code: "th" },

    { key: "vietnamese", label: "Vietnamese", code: "vi" },
    { key: "japanese", label: "Japanese", code: "ja" },
    { key: "indonesian", label: "Indonesian", code: "id" },
    { key: "malay", label: "Malay", code: "ms" },
  ];

  const [icon, setIcon] = useState("");
  useEffect(() => {
    console.log(icon, "icon");
  }, [icon]);
  useEffect(() => {
    console.log(faqTypes, "faqqqqqq");
  }, [faqTypes]);
  const handleCheckboxChange = (e) => {
    const value = e.target.value;

    if (e.target.checked) {
      // Add value to array
      setFaqTypes([...faqTypes, value]);
    } else {
      // Remove value from array
      setFaqTypes(faqTypes.filter((item) => item !== value));
    }
  };
  const addNewFaq = async () => {
    const isAllEmpty =
      Object.keys(titles).length === 0 ||
      Object.values(titles).every((v) => !v?.trim());
    const isAllDescEmpty =
      Object.keys(descriptions).length === 0 ||
      Object.values(descriptions).every((v) => !v?.trim());

    if (window.navigator.onLine) {
      if (isAllEmpty && isAllDescEmpty) {
        toast.warning(`Please fill at least one title or description`, {
          position: "top-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (faqTypes.length == 0) {
        toast.warning(`Please select any FAQ's Type`, {
          position: "top-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
      setloading(true);

      const formData = new FormData();
      formData.append("title", title);
      formData.append("desc", desc);
      formData.append("type", faqTypes);
      console.log(icon, "icon");
      formData.append("icon", icon);
      formData.append("video", faqVideo);
      formData.append("titles", JSON.stringify(titles));
      formData.append("description", JSON.stringify(descriptions));
      formData.append("keywords", faqkeywords);
      formData.append("status", status);

      const body = {
        title: title,
        desc: desc,
        type: setFaqTypes,
        icon: icon,
        video: faqVideo,
      };
      try {
        const responce = await axios.post(requests.addFaq, formData);
        if (responce.data.Success === 1) {
          // console.log(responce);
          toast.success("FAQ added successfully!!", {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setTimeout(() => {
            window.location.reload();
          }, 2500);
        } else {
          toast.warning(`something went wrong`, {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (err) {
        toast.warning(err, {
          position: "top-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      // console.log("body.....", body);
    } else {
      toast.error(`No internet connection`, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  return (
    <>
      <Sidebar />
      <Container className="content">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Card>
          <Card.Header className="heading">Add FAQ</Card.Header>
          <Card.Body>
            <Row>
              <Col className="main">
                <Form.Group className="mb-3">
                  <Form.Label>FAQ's Type*</Form.Label>
                  <Form.Check
                    type="checkbox"
                    label="Android"
                    value="android"
                    onChange={handleCheckboxChange}
                  />
                  <Form.Check
                    type="checkbox"
                    label="WebApp"
                    value="webapp"
                    onChange={handleCheckboxChange}
                  />
                  <Form.Check
                    type="checkbox"
                    label="MacOs"
                    value="macos"
                    onChange={handleCheckboxChange}
                  />
                  <Form.Check
                    type="checkbox"
                    label="IOS"
                    value="ios"
                    onChange={handleCheckboxChange}
                  />
                  <Form.Check
                    type="checkbox"
                    label="Windows"
                    value="windows"
                    onChange={handleCheckboxChange}
                  />
                  <Form.Check
                    type="checkbox"
                    label="Extension"
                    value="extension"
                    onChange={handleCheckboxChange}
                  />
                  <Form.Check
                    type="checkbox"
                    label="Website"
                    value="website"
                    onChange={handleCheckboxChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>FAQ Icon</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    placeholder="FAQ Icon"
                    onChange={(e) => {
                      e.target.files[0] == undefined
                        ? setIcon("")
                        : setIcon(e.target.files[0]);
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>FAQ Video</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="FAQ Video"
                    onChange={(e) => setFaqVideo(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>FAQ Keywords*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="FAQ Keyword(Comma separated)"
                    onChange={(e) => setFaqkeywords(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value={0}>Inactive</option>
                    <option value={1}>Active</option>
                  </Form.Select>
                </Form.Group>
                {LANGUAGES.map((lang) => (
                  <div key={lang.code}>
                    {/* Title */}
                    <Form.Group className="mb-3">
                      <Form.Label>
                        FAQ Title{lang.label == "English" ? "*" : ""} (
                        {lang.label})
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={`Title in ${lang.label}`}
                        value={titles[lang.code] || ""}
                        onChange={(e) =>
                          setTitles((prev) => ({
                            ...prev,
                            [lang.code]: e.target.value,
                          }))
                        }
                      />
                    </Form.Group>

                    {/* Description */}
                    <Form.Group className="mb-3">
                      <Form.Label>
                        FAQ Description {lang.label == "English" ? "*" : ""}(
                        {lang.label})
                      </Form.Label>
                      <ReactQuill
                        value={descriptions[lang.code] || ""}
                        onChange={(content) =>
                          setDescriptions((prev) => ({
                            ...prev,
                            [lang.code]: content,
                          }))
                        }
                      />
                    </Form.Group>
                  </div>
                ))}
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className="footer">
            {loading == true ? (
              <Loader margin={0} />
            ) : (
              <Button
                className="submit-btn"
                onClick={() => addNewFaq()}
                variant="primary"
              >
                Submit
              </Button>
            )}
          </Card.Footer>
        </Card>
      </Container>
    </>
  );
}

export default AddFaq;
